import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { Spotlight as AkSpotlight } from '@atlaskit/onboarding';
import type { SpotlightProps } from '@atlaskit/onboarding/types';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

import { MigratedSpotlight } from './MigratedSpotlight';
import { SpotlightTarget } from './SpotlightTarget';

export { SpotlightTarget };

const DeprecatedSpotlight = wrapComponentForChoreographer<SpotlightProps>(AkSpotlight);

type SpotlightComponent = ((
	props: SpotlightProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
			isMigrated?: boolean;
		},
) => React.ReactElement) & { displayName: string };

export const Spotlight: SpotlightComponent = (
	props: SpotlightProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
			isMigrated?: boolean;
		},
) => {
	const { isMigrated } = props;

	if (isMigrated && fg('post-office_enable_ads_spotlight_migration')) {
		return <MigratedSpotlight {...props} />;
	}

	return <DeprecatedSpotlight {...props} />;
};

Spotlight.displayName = 'ChoreographerSpotlight';
